import type {
  IHeroArticleSection,
  IHeroOverviewSection,
  IHeroProductSection
} from '~~/lib/ContentfulService';
import { mapHeadline } from '~/utils/mapHeadline';
import type {
  HeroProductSectionHeadlineProps as HeadlineProps,
  HeadlineModuleProps
} from '@hypercodestudio/basler-components';

import { isEntryResolveError } from '~/utils/guards/isEntryResolveError';
import { isDefined } from '~/utils/guards/isDefined';

export function mapHeroHeadline(
  heroItem: IHeroArticleSection | IHeroOverviewSection | IHeroProductSection,
  centeredText?: boolean
): HeadlineProps & HeadlineModuleProps {
  const advancedHeadline = heroItem.fields.advancedHeadline;

  if (isDefined(advancedHeadline) && !isEntryResolveError(advancedHeadline)) {
    const mappedHeadline = mapHeadline(advancedHeadline);

    return centeredText !== undefined
      ? { ...mappedHeadline, isCentered: centeredText }
      : mappedHeadline;
  }

  return {
    content: heroItem.fields.headline ?? '',
    level: 1,
    ...(centeredText !== undefined ? { isCentered: centeredText } : {}),
    badgeText: heroItem.fields.badge?.fields?.title,
    badgeSize: heroItem.fields.badge?.fields?.size ?? 'medium',
    badgeStyle: heroItem.fields.badge?.fields?.style,
    hasShineAnimation: heroItem.fields.badge?.fields.shineAnimation === 'yes'
  };
}
